(function (root, factory) {
  'use strict';
  var runtime = factory();
  if (typeof module === 'object' && module.exports) module.exports = runtime;
  if (root && root.customElements && root.HTMLElement) runtime.register(root);
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';

  var STORAGE_KEY = 'walden_geo_preference_v1';
  var ARTICLE_COUNTRIES = new Set(['US', 'NL', 'CZ', 'VA']);
  var HOST_STORES = {
    'waldencase.com': 'ar',
    'walden-cases.myshopify.com': 'ar',
    'store.waldencase.com': 'us',
    'walden-international.myshopify.com': 'us'
  };

  function hostIdentity(hostname) {
    var host = String(hostname || '').toLowerCase().replace(/^www\./, '').replace(/\.$/, '');
    return HOST_STORES[host] || host;
  }

  function safeDestination(value, currentURL) {
    try {
      var url = new URL(String(value || ''));
      if (url.protocol === 'http:' && url.hostname === 'store.waldencase.com' && !url.port) url.protocol = 'https:';
      if (url.protocol !== 'https:' || url.username || url.password || url.port || url.pathname !== '/' || url.search || url.hash) return null;
      if (hostIdentity(url.hostname) === hostIdentity(new URL(currentURL).hostname)) return null;
      return url.href;
    } catch (_) {
      return null;
    }
  }

  function matchesReferrer(referrer, destination) {
    if (!referrer) return false;
    try {
      return hostIdentity(new URL(referrer).hostname) === hostIdentity(new URL(destination).hostname);
    } catch (_) {
      return false;
    }
  }

  function countryCodes(value) {
    return new Set(String(value || '').split(/[\s,;]+/).map(function (code) { return code.trim().toUpperCase(); }).filter(function (code) { return /^[A-Z]{2}$/.test(code); }));
  }

  function detectedCountry(payload) {
    var detected = payload && payload.detected_values;
    var country = detected && detected.country;
    if (!country || typeof country !== 'object') return null;
    var code = String(country.handle || country.iso_code || '').toUpperCase();
    if (!/^[A-Z]{2}$/.test(code)) return null;
    return { code: code, name: typeof country.name === 'string' ? country.name : typeof detected.country_name === 'string' ? detected.country_name : '' };
  }

  function countryLabel(config, country) {
    var names = config.countryNames || {};
    var name = Object.prototype.hasOwnProperty.call(names, country.code) ? String(names[country.code]) : country.name || country.code;
    return config.showCountryArticle && ARTICLE_COUNTRIES.has(country.code) && !/^the\s/i.test(name) ? 'the ' + name : name;
  }

  function previewCountry(config, environment) {
    var code = String(config.previewCountry || 'US').toUpperCase();
    var name = typeof config.previewCountryName === 'string' ? config.previewCountryName : '';
    if (!name && /^[A-Z]{2}$/.test(code)) {
      try {
        var intl = environment.Intl || (typeof Intl !== 'undefined' ? Intl : null);
        if (intl && intl.DisplayNames) name = new intl.DisplayNames(['en'], { type: 'region' }).of(code) || '';
      } catch (_) {}
    }
    return { code: code, name: name || code };
  }

  function oldAppActive(content, decodeBase64) {
    if (content === null || typeof content === 'undefined') return false;
    var candidates = [String(content)];
    try { candidates.push(decodeURIComponent(candidates[0])); } catch (_) {}
    var decode = decodeBase64 || (typeof atob === 'function' ? atob : null);
    if (decode) candidates.slice().forEach(function (candidate) {
      try { candidates.push(decode(candidate)); } catch (_) {}
    });
    for (var attempt = 0; attempt < candidates.length; attempt += 1) {
      try {
        var parsed = JSON.parse(candidates[attempt]);
        return !(parsed && parsed.parameters && parsed.parameters.disabled_state === true);
      } catch (_) {}
    }
    return true;
  }

  function positiveSeconds(value, fallback) {
    var number = Number(value);
    return Number.isFinite(number) && number >= 0 ? Math.min(number, 86400) : fallback;
  }

  function createDismissals(environment) {
    var memory = null;
    function readCookie() {
      try {
        var parts = String(environment.document.cookie || '').split(';');
        var prefix = STORAGE_KEY + '=';
        var match = parts.map(function (part) { return part.trim(); }).find(function (part) { return part.indexOf(prefix) === 0; });
        return match ? decodeURIComponent(match.slice(prefix.length)) : null;
      } catch (_) { return null; }
    }
    function readRecords() {
      var values = [memory, readCookie()];
      try { values.push(environment.localStorage.getItem(STORAGE_KEY)); } catch (_) {}
      return values.map(function (value) {
        if (!value) return null;
        try { return typeof value === 'string' ? JSON.parse(value) : value; } catch (_) { return null; }
      }).filter(Boolean);
    }
    return {
      has: function (country, destination, now) {
        return readRecords().some(function (record) {
          return record.version === 1 && record.country === country && record.destination === destination && Number.isFinite(record.expiresAt) && record.expiresAt > now;
        });
      },
      save: function (country, destination, seconds, now) {
        var ttl = positiveSeconds(seconds, 600);
        if (!ttl) return;
        memory = { version: 1, country: country, destination: destination, expiresAt: now + ttl * 1000 };
        var value = JSON.stringify(memory);
        try { environment.localStorage.setItem(STORAGE_KEY, value); } catch (_) {}
        try {
          environment.document.cookie = STORAGE_KEY + '=' + encodeURIComponent(value) + '; Max-Age=' + Math.ceil(ttl) + '; Path=/; SameSite=Lax' + (environment.location.protocol === 'https:' ? '; Secure' : '');
        } catch (_) {}
      }
    };
  }

  async function fetchCountry(environment, endpoint, signal, timeoutMs) {
    var controller = new environment.AbortController();
    var timeout;
    var cancelResolve;
    var stopped = new Promise(function (resolve) { cancelResolve = resolve; });
    var abortListener = function () { controller.abort(); cancelResolve(null); };
    if (signal && signal.aborted) return null;
    if (signal) signal.addEventListener('abort', abortListener, { once: true });
    try {
      var url = new URL(endpoint || '/browsing_context_suggestions.json?country[enabled]=true', environment.location.href);
      if (url.origin !== environment.location.origin || !url.pathname.endsWith('/browsing_context_suggestions.json')) return null;
      timeout = environment.setTimeout(abortListener, timeoutMs === undefined ? 5000 : timeoutMs);
      var requested = (async function () {
        try {
          var response = await environment.fetch(url.href, { credentials: 'same-origin', headers: { Accept: 'application/json' }, signal: controller.signal });
          if (!response.ok || controller.signal.aborted) return null;
          var payload = await response.json();
          return controller.signal.aborted ? null : detectedCountry(payload);
        } catch (_) { return null; }
      })();
      return await Promise.race([requested, stopped]);
    } catch (_) {
      return null;
    } finally {
      if (timeout !== undefined) environment.clearTimeout(timeout);
      if (signal) signal.removeEventListener('abort', abortListener);
      controller.abort();
    }
  }

  function renderMessage(document, element, config, country) {
    var chunks = String(config.message || '').split('%COUNTRY%');
    var fragment = document.createDocumentFragment();
    chunks.forEach(function (chunk, index) {
      if (index) {
        var span = document.createElement('span');
        span.className = 'walden-geo-country';
        span.style.fontWeight = 'bold';
        if (config.showFlag && typeof config.flagPrefix === 'string') {
          var flag = document.createElement('img');
          flag.className = 'walden-geo-flag';
          flag.src = config.flagPrefix + country.code.toLowerCase() + (config.flagSuffix || '.svg');
          flag.width = 20;
          flag.height = 15;
          flag.alt = '';
          flag.setAttribute('aria-hidden', 'true');
          span.appendChild(flag);
        }
        span.appendChild(document.createTextNode(countryLabel(config, country)));
        fragment.appendChild(span);
      }
      fragment.appendChild(document.createTextNode(chunk));
    });
    element.replaceChildren(fragment);
  }

  function register(environment) {
    if (environment.customElements.get('walden-geo-popup')) return;
    var dismissals = createDismissals(environment);
    var pageDismissals = new Set();
    class WaldenGeoPopup extends environment.HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new environment.AbortController();
        this.initialize(this.controller.signal);
      }

      disconnectedCallback() {
        if (this.controller) this.controller.abort();
        environment.clearTimeout(this.showTimer);
        if (this.dialog && this.dialog.open) this.dialog.close();
        this.removeAttribute('data-walden-geo-open');
        this.controller = null;
      }

      async initialize(signal) {
        try {
          var configNode = this.querySelector('[data-geo-config]');
          var config = JSON.parse(configNode ? configNode.textContent : '{}');
          var designMode = !!(environment.Shopify && environment.Shopify.designMode);
          var preview = designMode && config.preview === true;
          if (designMode && !preview) return;
          if (!config.enabled && !preview) return;
          var previousApp = environment.document.querySelector('meta.geo-ip');
          if (!designMode && previousApp && oldAppActive(previousApp.getAttribute('content'), environment.atob ? environment.atob.bind(environment) : undefined)) return;
          var destination = safeDestination(config.destination, environment.location.href);
          if (!destination || (!preview && matchesReferrer(environment.document.referrer, destination))) return;
          var dialog = this.querySelector('[data-geo-dialog]');
          var message = this.querySelector('[data-geo-message]');
          var go = this.querySelector('[data-geo-go]');
          if (!dialog || !message || !go || typeof dialog.showModal !== 'function') return;
          this.dialog = dialog;
          var country = preview ? previewCountry(config, environment) : await fetchCountry(environment, config.countryEndpoint, signal);
          if (signal.aborted || !this.isConnected || !country || !/^[A-Z]{2}$/.test(country.code)) return;
          var pageKey = country.code + ':' + destination;
          if (!preview && (!countryCodes(config.countryCodes).has(country.code) || pageDismissals.has(pageKey) || dismissals.has(country.code, destination, Date.now()))) return;
          renderMessage(environment.document, message, config, country);
          this.setAttribute('data-geo-country', country.code);
          var close = () => {
            if (!preview) pageDismissals.add(pageKey);
            if (!preview && positiveSeconds(config.closeSeconds, 0) > 0) dismissals.save(country.code, destination, config.closeSeconds, Date.now());
            dialog.close();
            this.removeAttribute('data-walden-geo-open');
          };
          var options = { signal: signal };
          var closeButton = this.querySelector('[data-geo-close]');
          if (closeButton) closeButton.addEventListener('click', close, options);
          dialog.addEventListener('cancel', function (event) { event.preventDefault(); close(); }, options);
          dialog.addEventListener('close', () => { this.removeAttribute('data-walden-geo-open'); }, options);
          var stay = this.querySelector('[data-geo-stay]');
          if (stay) stay.addEventListener('click', () => {
            if (!preview) {
              pageDismissals.add(pageKey);
              dismissals.save(country.code, destination, config.staySeconds, Date.now());
            }
            dialog.close();
            this.removeAttribute('data-walden-geo-open');
          }, options);
          go.addEventListener('click', function () {
            if (!preview) environment.location.assign(destination);
          }, options);
          var show = () => {
            if (signal.aborted || !this.isConnected || dialog.open || environment.document.querySelector('[data-walden-geo-open="true"]')) return;
            try {
              dialog.showModal();
              if (typeof dialog.focus === 'function') dialog.focus({ preventScroll: true });
              this.setAttribute('data-walden-geo-open', 'true');
            } catch (_) {}
          };
          var delay = preview ? 0 : positiveSeconds(config.delaySeconds, 0) * 1000;
          if (delay) this.showTimer = environment.setTimeout(show, delay);
          else show();
        } catch (_) {}
      }
    }
    environment.customElements.define('walden-geo-popup', WaldenGeoPopup);
  }

  return {
    STORAGE_KEY: STORAGE_KEY,
    hostIdentity: hostIdentity,
    safeDestination: safeDestination,
    matchesReferrer: matchesReferrer,
    countryCodes: countryCodes,
    detectedCountry: detectedCountry,
    countryLabel: countryLabel,
    previewCountry: previewCountry,
    oldAppActive: oldAppActive,
    createDismissals: createDismissals,
    fetchCountry: fetchCountry,
    renderMessage: renderMessage,
    register: register
  };
});
